export default "__VITE_ASSET__axwbhZb4__"